import { useEffect, useState } from 'react'
import { VehicleDetailsData } from '../components/VehicleDetailsForm/types'
import { useApiRequest } from 'hooks/useApiRequest'
import { referencesApi } from 'api'

export const useInitVehicleData = ({
  supplierId,
  isAccountPending,
}: {
  supplierId: string
  isAccountPending?: boolean
}) => {
  const [vehicleDetailsData, setVehicleDetailsData] =
    useState<VehicleDetailsData>({
      carCategories: [],
      cars: [],
      carTypes: [],
      doors: [],
      seats: [],
      locations: [],
    })

  const getAllCarGroupsRequest = useApiRequest(() =>
    referencesApi.getAllCarGroups()
  )
  const getAllCarsRequest = useApiRequest(() =>
    referencesApi.getAllCars(supplierId)
  )
  const getAllCarTypesRequest = useApiRequest(() =>
    referencesApi.getAllCarTypes()
  )

  const getCarSeatsRequest = useApiRequest(() => referencesApi.getCarSeats())

  const getCarDoorsRequest = useApiRequest(() => referencesApi.getCarDoors())

  const getAllCompanyHirePointsRequest = useApiRequest((companyId) =>
    referencesApi.getAllCompanyHirePoints(companyId)
  )

  useEffect(() => {
    if (!isAccountPending) {
      const fetchVehicleDetailsData = async () => {
        const [carCategories, cars, carTypes, seats, doors, locations] =
          await Promise.all([
            getAllCarGroupsRequest.apiRequest(),
            getAllCarsRequest.apiRequest(),
            getAllCarTypesRequest.apiRequest(),
            getCarSeatsRequest.apiRequest(),
            getCarDoorsRequest.apiRequest(),
            getAllCompanyHirePointsRequest.apiRequest(supplierId),
          ])
        if (carCategories && cars && carTypes && seats && doors && locations) {
          setVehicleDetailsData((prev) => ({
            ...prev,
            carCategories: carCategories.data.items,
            cars: cars.data.items,
            carTypes: carTypes.data.items,
            doors: doors.data.items,
            seats: seats.data.items,
            locations: locations.data.items,
          }))
        }
      }
      fetchVehicleDetailsData()
    }
  }, [])

  return {
    vehicleDetailsData,
    isLoaded:
      getAllCarGroupsRequest.isLoaded &&
      getAllCarsRequest.isLoaded &&
      getAllCarTypesRequest.isLoaded &&
      getCarDoorsRequest.isLoaded &&
      getCarSeatsRequest.isLoaded &&
      getAllCompanyHirePointsRequest.isLoaded,
  }
}
